module.exports = __webpack_public_path__ + "images/referenzen/produktfilm/rosenthal_tac_kollektionsfilm_small.jpg";